import React, { useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './Navbar.css';

const Navbar: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  
  // 检查是否在作品详情页面
  const isProductDetailPage = location.pathname.startsWith('/product/');
  
  // 处理返回按钮点击
  const handleBackClick = () => {
    navigate(-1); // 返回上一页
  };

  // 键盘快捷键支持
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      // 只在作品详情页面启用快捷键
      if (!isProductDetailPage) return;
      
      // ESC键返回
      if (event.key === 'Escape') {
        event.preventDefault();
        handleBackClick();
      }
      
      // Alt + 左箭头返回（浏览器标准快捷键）
      if (event.altKey && event.key === 'ArrowLeft') {
        event.preventDefault();
        handleBackClick();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [isProductDetailPage, navigate]);

  console.log('logo url:', `${process.env.PUBLIC_URL}/images/logo.svg`);
  
  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-left">
          {/* 返回按钮 - 只在作品详情页显示 */}
          {isProductDetailPage && (
            <button 
              className="navbar-back-btn" 
              onClick={handleBackClick}
              title="Go back (ESC or Alt+←)"
            >
              <svg 
                width="20" 
                height="20" 
                viewBox="0 0 24 24" 
                fill="none" 
                stroke="currentColor" 
                strokeWidth="2"
              >
                <path d="M19 12H5M12 19l-7-7 7-7"/>
              </svg>
              <span>Back</span>
            </button>
          )}
          
          {/* Logo */}
          <div className="navbar-logo">
            <Link to="/">
              <img
                src="/images/logo.svg"
                alt="Artizim"
                style={{ height: 36 }}
              />
            </Link>
          </div>
        </div>

        {/* 导航菜单 - 始终显示 */}
        <div className="navbar-menu">
          <Link
            to="/"
            className={`navbar-item ${location.pathname === '/' ? 'active' : ''}`}
          >
            Work
          </Link>
          <Link
            to="/about"
            className={`navbar-item ${location.pathname === '/about' ? 'active' : ''}`}
          >
            About
          </Link>
          <Link
            to="/contact"
            className={`navbar-item ${location.pathname === '/contact' ? 'active' : ''}`}
          >
            Contact
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;